import { EVENTS } from '../../../../../../../library';

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.COMPONENTS.APPLICATION.REWARDS.EARN.MORE_INFO_MODAL[event];
};

export const TRANSLATION_PATH = (route) => {
  return `components.application.rewards.earn.achievementCard.moreInfoModal.${route}`;
};
